import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type CurrentTeamStore = {
    workspaceId?: string;
    teamId?: string;
    setCurrentWorkspaceId: (workspaceId?: string) => void;
    setCurrentTeamId: (teamId?: string) => void;
};

export const useCurrentTeamStore = create(
    persist<CurrentTeamStore>(
        (set) => ({
            workspaceId: '',
            teamId: '',

            setCurrentWorkspaceId: (workspaceId) => set(() => ({ workspaceId })),
            setCurrentTeamId: (teamId) => set(() => ({ teamId })),
        }),
        {
            name: 'current-workspace',
            version: 3,
        }
    )
);
